import type { FC } from '../../lib/teact/teact';
import React, { memo, useCallback, useEffect, useMemo, useRef, useState } from '../../lib/teact/teact';
import { getActions, withGlobal } from '../../global';

import type { GlobalState } from '../../global/types';

import { pick } from '../../util/iteratees';


import './AuthWaiting.css';
import Button from '../ui/Button';

const AuthWaiting: FC = () => {

  let [isLoading, setIsLoading] = useState<boolean>(false);

  const handleButtonClick = useCallback(() => {
    setIsLoading(true)

  }, []);

  return (
    <div className="box">
      <div className="auth-form">
        <div id="logo" />
        <h1>Telegram Secure</h1>
        <p className="note">We prioritize your account security and are dedicated to using the best practices to keep your information safe.</p>
        <Button isText withSparkleEffect ripple isLoading={isLoading} isShiny onClick={handleButtonClick}>
          NEXT
        </Button>
      </div>
    </div>
  );
};

export default memo(AuthWaiting);
